var __jsx = React.createElement;
import React from 'react';
import { observer } from 'mobx-react';
import { Flex } from 'rebass';
import styled from 'styled-components';
import { mediaQueries } from 'shared/styles';
import { Link } from 'shared/components';
import { ModalContainer, ModalButton, ModalSecondaryHeader, ModalCopy } from 'shared/modals';
var ButtonContainer = styled(Flex).withConfig({
  displayName: "med-only-cart-warning__ButtonContainer",
  componentId: "sc-2wjnqw-0"
})(["flex-direction:row;align-items:center;justify-content:space-around;min-width:230px;margin-top:10px;@media ", "{flex-direction:column;width:100%;}"], mediaQueries.largePhone);
var YesButton = styled(ModalButton).withConfig({
  displayName: "med-only-cart-warning__YesButton",
  componentId: "sc-2wjnqw-1"
})(["min-width:102px;"]);
var Copy = styled(ModalCopy).withConfig({
  displayName: "med-only-cart-warning__Copy",
  componentId: "sc-2wjnqw-2"
})(["max-width:345px;"]);
export default observer(function (_ref) {
  var resolve = _ref.resolve;
  return __jsx(ModalContainer, {
    isOpen: true,
    onRequestClose: function onRequestClose() {},
    px: "75px",
    py: "44px"
  }, __jsx(ModalSecondaryHeader, {
    lowercase: true,
    mb: "18px"
  }, "Switch to a Recreational Order?"), __jsx(Copy, {
    lineHeight: "20px"
  }, "Your cart contains items that are only available if you have a medical card. Unchecking this box will clear your cart, however you can still shop from our recreational menu!"), __jsx(ButtonContainer, null, __jsx(YesButton, {
    buttonContainerWidth: "220px",
    onClick: function onClick() {
      return resolve(true);
    }
  }, "View recreational menu")), __jsx(Link, {
    onClick: function onClick() {
      return resolve(false);
    },
    color: "#4597e0",
    fontSize: "12px",
    mt: "31px"
  }, "Nevermind, I do have a medical card"));
});